import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import XoxoTokenReports from "../../modules/Reports/XoxoTokenReports";
import {
  PlatformPreferences,
  Recharge,
  GenerateBrandVoucher,
  ListingBrandVouchers,
  PlumProReport,
  VoucherRecharge,
  Report,
  EmpulsReport,
  PlumPoints,
  Campaign,
  BulkUpload,
  Wallet,
  XoxoTokenReport,
  PerksReport,
  Funds,
  ActivityLog,
  Profile,
  XoxoLink,
  XoxoCode,
  XoxoCodeNew,
  DiwaliGifting,
  XoxoLinkNew,
  PlumPro,
  XoxoLinkCampaign,
  XoxoCodeCampaign,
  EmailPreviewScreen,
  IntegrationsDashboard,
  SapSuccessfactors,
  Darwin,
  DiyDashboard,
  XoxolinkEmailPreview,
  BrandVerifications,
  Integrations,
  AutomationCreation,
  AutomationDetails,
  AutomationSuccess,
  Templates,
} from "../../config/loadableImports";

import { ACL_MODULE_MAPPING } from "../../constants/RouteConstant";
import AccessDenied from "../AccessDenied";
import { adminRole } from "../../constants/AppConstant";
import DomainAuthentication from "../../modules/Integrations/DomainAuthentication";
import XoxoPointsNew from "../../modules/XoxoPointsNew";
import { getDefaultRoute } from "../../utils/globals";
import RewardLandingPage from "../RewardLandingPage";

const NoPageFound = ({ accountReducer }) => {
  return (
    <AccessDenied
      heading={"No Page Found"}
      text={"Oops! Looks like you are Lost"}
      accountReduce={accountReducer}
    />
  );
};

class PrivateRoutes extends React.Component {
  renderAccessDinied(heading = "", text = "") {
    return (
      <AccessDenied
        heading={heading}
        text={text}
        accountReducer={this.props.accountReducer}
      />
    );
  }

  render() {
    let currentUrl = this.props.location?.pathname;
    const {
      adminPrefix,
      accountReducer: {
        moduleAcl = [],
        typeData: { walletCompany = 1, role = 1 } = {},
        kybStatus: { kyb_status = 0 } = {},
      },
    } = this.props;
    let moduleAclArray = moduleAcl.map((item) => item.module_id);
    if (moduleAclArray.length === 0) return "";
    const link = getDefaultRoute(moduleAclArray, kyb_status);
    return (
      <Switch>
        <Route
          exact={true}
          path="/admin/"
          render={(props) => <Redirect to={adminPrefix + link} />}
        />

        <Route
          exact={true}
          path={adminPrefix + "accounts/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) &&
            walletCompany &&
            adminRole.admin === role ? (
              <Redirect to={`${adminPrefix}accounts/platform-preferences/`} />
            ) : moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) ? (
              <Redirect to={`${adminPrefix}accounts/manage-admins/`} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "dashboard/"}
          render={(props) => <DiyDashboard {...this.props} />}
        />

        <Route
          path={adminPrefix + "verifications/:productId"}
          render={(props) => <BrandVerifications {...this.props} {...props} />}
        />

        <Route
          path={adminPrefix + "listing-brand-vouchers/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ? (
              <ListingBrandVouchers {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact
          path={adminPrefix + "campaign/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <Redirect
                to={adminPrefix + "accounts/platform-preferences#catalog"}
              />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "campaign/xoxo-link-campaign"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <XoxoLinkCampaign {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "campaign/xoxo-campaign/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN) ? (
              <XoxoCodeCampaign {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "campaign/xoxo-code-campaign/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN) ? (
              <XoxoCodeCampaign {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "recharge/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.RECHARGE) ? (
              <Recharge {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        {/* <Route
          path={adminPrefix + "generate-brand-voucher/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ? (
              <GenerateBrandVoucher {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        /> */}

        <Route
          path={adminPrefix + "generate-brand-voucher/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ? (
              <PlumPro {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact
          path={adminPrefix + "reports/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.REPORTS) ? (
              <Report {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "reports/plum-pro-report/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <PlumProReport {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "reports/empuls-report/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.EMPULS) ? (
              <EmpulsReport {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "reports/voucher-recharge/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.REPORTS) ? (
              <VoucherRecharge {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "reports/perks-report/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.PERKS) ? (
              <PerksReport {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "card-redeem-history/"}
          render={(props) => <GiftCardRedeemHistory {...this.props} />}
        />
        <Route
          path={adminPrefix + "point-redeem-history/"}
          render={(props) => <PointsRedeemHistory {...this.props} />}
        />
        <Route
          path={adminPrefix + "on-redemption-voucher/"}
          render={(props) => <OnRedemptionVoucher {...this.props} />}
        />

        <Route
          path={adminPrefix + "xoxo-points/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ? (
              <XoxoPointsNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "bulkupload/"}
          render={(props) => <BulkUpload {...this.props} />}
        />

        {/* <Route
          exect
          path={"/admin/awards"}
          render={(props) => <Awards {...this.props} />}
        />

        <Route
          path={"/admin/create"}
          render={(props) => <AwardsCreate {...this.props} />}
        /> */}

        <Route
          exact={true}
          path={adminPrefix + "xoxo-code/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <XoxoCodeNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={adminPrefix + "holiday-gifting/send/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <XoxoCodeNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={adminPrefix + "gifting/diwali-gifting/send/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
              moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <XoxoCodeNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={adminPrefix + "holiday-gifting/send-link/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <XoxoLinkNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={adminPrefix + "holiday-gifting/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <DiwaliGifting {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "gifting/:gifting_id"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ? (
              <RewardLandingPage
                {...this.props}
                routePath={props.match.params.gifting_id}
              />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        {/* Dynamic Reward Routes - Generated from rewardUseCasesAndOccasions data */}

        <Route
          path={adminPrefix + "wallet/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.WALLET) ? (
              <Wallet {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          path={adminPrefix + "reports/xoxo-token-report/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.WALLET) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <XoxoTokenReport {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          path={adminPrefix + "reports/xoxo-token-reports/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.WALLET) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <XoxoTokenReports {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        {/* <Route
          path={"/admin/view-campaign/:id"}
          render={(props) => <ViewCampaign {...this.props} />}
        />
        <Route
          path={"/admin/edit-campaign/:id"}
          render={(props) => <ViewCampaign {...this.props} />}
        /> */}

        <Route
          exact={true}
          path={adminPrefix + "accounts/platform-preferences/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) &&
            walletCompany ? (
              <PlatformPreferences
                {...this.props}
                moduleAclArray={moduleAclArray}
              />
            ) : moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) &&
              !walletCompany ? (
              <PlatformPreferences
                {...this.props}
                showAdmin={true}
                moduleAclArray={moduleAclArray}
              />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "accounts/manage-admins/"}
          render={
            (props) =>
              moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) &&
              walletCompany ? (
                <Funds {...this.props} />
              ) : moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) &&
                !walletCompany ? (
                <Profile {...this.props} showAdmin={true} />
              ) : (
                this.renderAccessDinied()
              )

            // moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) ? (
            // 	walletCompany ? <Funds {...this.props} /> : <Profile {...this.props} showAdmin = {true}/>
            // ) : this.renderAccessDinied()
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "accounts/activity-log/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) ? (
              <ActivityLog {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "accounts/profile/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.ACCOUNT) ? (
              <Profile {...this.props} showAdmin={false} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact
          path={adminPrefix + "xoxo-link/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
              <XoxoLinkNew {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={adminPrefix + "integrations/automation/:id"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <AutomationCreation {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={
            adminPrefix + "integrations/dashboard/:integrationtype/view/:id"
          }
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <AutomationDetails {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />

        <Route
          exact={true}
          path={
            adminPrefix + "integrations/automation/:integrationtype/success"
          }
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <AutomationSuccess {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        {
          <Route
            exact={true}
            path={adminPrefix + "integrations/dashboard/:id"}
            render={(props) =>
              moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
                <Integrations {...this.props} />
              ) : (
                this.renderAccessDinied()
              )
            }
          />
        }
        <Route
          exact={true}
          path={adminPrefix + "xoxo-voucher/email-preview-screen/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <EmailPreviewScreen {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={adminPrefix + "xoxo-link/email-preview-screen/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <XoxolinkEmailPreview {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        {/* <Route
          exact={true}
          path={adminPrefix + "integration/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <SurveyMonkey {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        */}

        <Route
          exact={true}
          path={adminPrefix + "integration-dashboard/manage-integration/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <IntegrationsDashboard {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route
          exact={true}
          path={
            adminPrefix +
            "integration-dashboard/manage-integration/configure/sap_successfactors"
          }
          render={(props) => <SapSuccessfactors {...this.props} />}
        />
        <Route
          exact={true}
          path={
            adminPrefix +
            "integration-dashboard/manage-integration/configure/darwin"
          }
          render={(props) => <Darwin {...this.props} />}
        />
        <Route
          exact={true}
          path={
            adminPrefix +
            "integration-dashboard/manage-integration/configure/darwin"
          }
          render={(props) => <Darwin {...this.props} />}
        />
        <Route
          exact={true}
          path={adminPrefix + "senderDomain"}
          render={(props) => <DomainAuthentication {...this.props} />}
        />
        <Route
          exact={true}
          path={adminPrefix + "templates/"}
          render={(props) =>
            moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON) ? (
              <Templates {...this.props} />
            ) : (
              this.renderAccessDinied()
            )
          }
        />
        <Route component={NoPageFound} />
      </Switch>
    );
  }
}

export default withRouter(PrivateRoutes);
